import React from 'react';

import { StoreProvider, StoreProviderProps } from '@store';

export type AppStoreProviderProps = {
  reduxStore: StoreProviderProps['store'];
  children?: React.ReactNode;
};

export const AppStoreProvider: React.FC<AppStoreProviderProps> = ({ children, reduxStore }) => {
  return (
    <StoreProvider loading={null} store={reduxStore}>
      {children}
    </StoreProvider>
  );
};

export default AppStoreProvider;
